export default function Router($stateProvider) {
    "ngInject";

    $stateProvider
        .state({
            name: "booths",
            url: "/app/devices",
            template: "<booths></booths>",
            resolve: {
                $title: () => "Devices | UpReach Cloud"
            }
        });
}


// WEBPACK FOOTER //
// ./sources/components/booths/booths-router.js